import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Stepper from "../../Components/Stepper";
import Toast from "../../Components/Toast";
import { toast } from "react-hot-toast";
import { useFormik } from "formik";
import { validateOtp } from "../../_common/Validation";
import {
  Get,
  Post,
  AuthFile,
  AuthGet,
  AuthPost,
} from "../../_common/httpService";
import brandlogo from "../../assets/images/brand_logo.svg";
import UserAvatar from "../../Components/UserAvatar/UserAvatar";
// import { AuthFile, AuthGet, AuthPost } from "../../_common/httpService";

export const VerifyOtp = () => {
  const navigate = useNavigate();
  // const tenantId = sessionStorage.getItem("tenantId");

  const [logo, setLogo] = useState();
  const [isThemeExists, setIsThemExists] = useState(true);
  console.log("isThemeExists::: ", isThemeExists);
  let productId = sessionStorage.getItem("ProductId");
  let verticalId = sessionStorage.getItem("VerticalId");
  let tenantId = sessionStorage.getItem("tenantId");
  let subscriptionId = sessionStorage.getItem("subscriptionId");
  const addNewSubscription = JSON.parse(
    sessionStorage.getItem("newSubscription")
  );
  const [timer, setTimer] = useState(180);

  useEffect(() => {
    const countdown = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        clearInterval(countdown);
      }
    }, 1000);

    return () => clearInterval(countdown);
  }, [timer]);

  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  const formikOtpVerify = useFormik({
    initialValues: {
      phoneotp: "",
      emailotp: "",
    },

    validate: validateOtp,
    // validationSchema: validateOtp,
    // enableReinitialize: true,

    onSubmit: async (values) => {
      const params = {
        tenantId: sessionStorage.getItem("tenantId"),
        themeId: sessionStorage.getItem("selectedthemeid"),
        theme: sessionStorage.getItem("themename"),
        subscriptionId: sessionStorage.getItem("subscriptionId"),
      };
      const resp = await Get(`tenant/tenant-emailphone/${tenantId}`);
      if (resp.statusCode === 200) {
        values.email = resp?.data?.email;
        values.subscriptionId = sessionStorage.getItem("subscriptionId");
        await Post("tenant/otp-verify", values)
          .then((res) => {
            if (res.statusCode === 200) {
              toast.success("Success");

              try {
                AuthFile(
                  `tenant-theme/${params.subscriptionId}`,
                  params,
                  "patch"
                ).then((res) => {
                  console.log("res:::2 ", res);
                  if (res.statusCode === 200) {
                    triggerBuild();
                    publish();
                    sessionStorage.setItem("build", "Yes");
                    // triggerOtp();
                    // navigate("/verify-otp");/
                  }
                });
              } catch (error) {
                console.log("error::: ", error);
              }

              if (addNewSubscription) {
                sessionStorage.removeItem("newSubscription");
              }
              setTimeout(() => navigate("/congratulations"), 2000);

              formikOtpVerify.resetForm();
            } else if (res.statusCode === 400) {
              toast.error("Invalid Email & Mobile Otp");
            }
          })
          .catch((err) => {
            const errObj = JSON.parse(err.message);
            toast.error(errObj.data.message);
          });
      }
    },
  });

  const handleResendOTP = async () => {
    try {
      formikOtpVerify.resetForm();
      let resp = await Post(`tenant/generate-otp/${tenantId}`);
      if (resp.statusCode === 200) {
        toast.success("OTP resent to phone and email");
      }
    } catch (error) {
      console.log("error::: ", error);
    }
  };

  const triggerBuild = async () => {
    await Post(`tenant/generate-build/${subscriptionId}`, {});
    return;
  };

  const publish = () => {
    AuthGet(`configuration/list/${subscriptionId}`)
      .then((res) => {
        if (res.tenants) {
          const defaultValues = {
            plaidEnv: "sandbox",
            plaidClientId: process.env.REACT_APP_PLAID_CLIENT_ID,
            plaidSecret: process.env.REACT_APP_PLAID_SECRET_KEY,
            sendGridAPIKey: process.env.REACT_APP_SEND_GRID_KEY,
          };
          const details = res.tenants[0];
          const params = {
            PLAID_ENV: (details && details.plaidEnv) || defaultValues.plaidEnv,
            PLAID_CLIENT_ID:
              (details && details.plaidClientId) || defaultValues.plaidClientId,
            PLAID_SECRET_KEY:
              (details && details.plaidSecret) || defaultValues.plaidSecret,
            SENDGRID_KEY:
              (details && details.sendGridAPIKey) ||
              defaultValues.sendGridAPIKey,
            SUBSCRIPTION_ID: subscriptionId,
            BUSINESS_NAME: res.data.businessName
              .replace(/\s/g, "")
              .toLowerCase(),
            token: "qwerty201",
            STYLE: "style",
            THEECODE_KEY: res.data.key,
            THEECODE_USERNAME: res.data.userName,
            THEECODE_URL: process.env.REACT_APP_UIUrl,
            THEECODE_SETTINGS_URL:
              process.env.REACT_APP_UIUrl +
              `/control-panel/?username=${encodeURIComponent(
                res.data.userName
              )}&key=${encodeURIComponent(
                res.data.key
              )}&subscription_id=${encodeURIComponent(subscriptionId)}`,
            USER_PASSWORD: res.data.password,
            USER_SALT: res.data.salt,
            USER_EMAIL: res.data.email,
          };
          AuthPost(`configuration/publish`, params).then((resp) => {
            const subParam = {
              subscriptionss: [
                {
                  publish: "Published",
                },
              ],
            };
            const sub = {
              subscriptions: [
                {
                  verticalId: verticalId,
                  tenantId: tenantId,
                  businessName: params.BUSINESS_NAME,
                  status: "Active",
                },
              ],
            };
            // toast.success("Build triggered! You will receive an email once its ready")
            // updateSubscrip(sub)
          });
        }
      })
      .catch((err) => {});
  };

  return (
    <>
    
      <Toast />
       {/* <div className="fullScreen_bg p0"> */}
      <div className="topHeader">
        <div className="displayFlex Alignitem_center width_100per">
          <div>
            {" "}
            <div className="logosection headerinherit">
              <div className="displayFlex">
                {/* <img src={menuicon} className="mobileMenuicon" /> */}
                <div className="brand_logo">
                  <img src={brandlogo} alt="brand_logo" />
                </div>
              </div>
            </div>
          </div>

              {" "}
              <Stepper />

          <div>
            {addNewSubscription === true ? (
              <UserAvatar
                logout={true}
                quickGuide={true}
                business={true}
                changePassword={true}
                profile={true}
              />
            ) : (
              <UserAvatar logout={true} />
            )}
          </div>
        </div>
      </div>

      {/* <div className="full_header">
        <div className=" ">
          <div className="pagecontentblock"> */}
            <div className="p40">
              <form className="otpblock">
                <h3 className="mb_24 fontSize16 fontWeight_600 blackText">
                  OTP Verification
                </h3>
                {/* <div className="row justifyContent_center p0 "> */}
          <div className="form-group mb_24">
                    <div className="float-label">
                      <label className="labeltext" htmlFor="phoneotp">
                        Mobile OTP
                      </label>
                      <input
                        type="tel" // Restricts to numbers on mobile
                        placeholder="Enter Mobile OTP"
                        id="phoneotp"
                        className="adminInput border_bottomgrey"
                        name="phoneotp"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                          formikOtpVerify.setFieldValue("phoneotp", value);
                        }}
                        onBlur={formikOtpVerify.handleBlur}
                        value={formikOtpVerify.values.phoneotp}
                        maxLength={6} // Adjust OTP length as needed
                      />
                    </div>
                    {formikOtpVerify.touched.phoneotp &&
                    formikOtpVerify.errors.phoneotp ? (
                      <p className="error_text text-danger">
                        {formikOtpVerify.errors.phoneotp}
                      </p>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <div className="float-label">
                      <label className="labeltext" htmlFor="emailotp">
                        Email OTP
                      </label>
                      <input
                        type="tel" // Ensures only numbers can be entered
                        placeholder="Enter Email OTP"
                        id="emailotp"
                        className="adminInput border_bottomgrey"
                        name="emailotp"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                          formikOtpVerify.setFieldValue("emailotp", value);
                        }}
                        onBlur={formikOtpVerify.handleBlur}
                        value={formikOtpVerify.values.emailotp}
                        maxLength={6} // Adjust OTP length as needed
                      />
                    </div>
                    {formikOtpVerify.touched.emailotp &&
                    formikOtpVerify.errors.emailotp ? (
                      <p className="error_text text-danger">
                        {formikOtpVerify.errors.emailotp}
                      </p>
                    ) : null}
                    <div className="resend-otp">
                      {timer > 0 ? (
                        <span>
                          Resend OTP in {minutes.toString().padStart(2, "0")}:
                          {seconds.toString().padStart(2, "0")}
                        </span>
                      ) : (
                        <span
                          onClick={handleResendOTP}
                          className="blueWithUnderscore"
                        >
                          Resend OTP
                        </span>
                      )}
                    </div>
                  </div>

                <div className="textAlign_center">
                  <button
                    className="Mainbutton"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      formikOtpVerify.submitForm();
                    }}
                  >
                    Continue
                  </button>
                </div>
              </form>
            </div>
          {/* </div> */}
        {/* </div> */}
      {/* </div> */}
    {/* </div > */}
      </>
   
     
  );
};
